import type { BlockerModel } from '../../types';
import type { TileModel } from './TileModel';
import type { TileStackModel } from './TileStackModel';

export enum BoardEventType {
  MoveMade = 'MoveMade',
  TilesRemoved = 'TilesRemoved',
  TileRemovedFinished = 'TileRemovedFinished',
  TileMoved = 'TileMoved',
  BlockerRemoved = 'BlockerRemoved',
  BlockerChanged = 'BlockerChanged',
  CollectableRelease = 'CollectableRelease',
  StacksSwapped = 'StacksSwapped',
}

export enum TileRemovalReason {
  Booster = 'Booster',
  Transfer = 'Transfer',
  Match = 'Match',
  Revive = 'Revive',
  Blocker = 'Blocker',
}

export const TILE_MATCH_REASONS: TileRemovalReason[] = [TileRemovalReason.Match, TileRemovalReason.Blocker];

export interface MoveMadeEvent {
  stackId: string;
  tilesIds: string[];
  tiles: TileModel[];
}

export interface TileRemovedEvent {
  id: string;
  stackId: string;
  tileIds: string[];
  tiles: TileModel[];
  time: number;
  reason: TileRemovalReason;
}

export interface TileRemovedFinishedEvent {
  id: string;
  stackId: string;
}

export interface TileMovedEvent {
  id: string;
  fromStackId: string;
  toStackId: string;
  time: number;
  tileIds: string[];
}

export interface BlockerRemovedEvent {
  id: string;
  stackId: string;
  blockerId: string;
  blocker: BlockerModel;
  time: number;
}

export interface BlockerChangedEvent {
  id: string;
  stackId: string;
  blockerId: string;
}

export interface CollectableEvent {
  stack: TileStackModel;
}

export interface StacksSwappedEvent {
  id: string;
  stackId: string;
  otherStackId: string;
}
